import OperatingRoomIndicatorsPage from './components/OperatingRoomIndicatorsPage'
import '../../components/summary/Summary.scss'
import './OperatingRoomIndicators.scss'

/**
 * Indicadores de quirófano (reemplaza a `operatingroomstaticsview` de Vaadin, el viewpath del menú 2041). Una sola pantalla con
 * pestañas: evolución, mapa de calor, quirófanos, agrupado y lista. No tiene subrutas: el drill-down a la lista es una pestaña.
 * No es el «Libro de quirófano» (`OperationRoomStatisticsView`).
 */
export default function OperatingRoomIndicatorsView() {
  return <OperatingRoomIndicatorsPage />
}
